export default __webpack_public_path__ + "static/media/logo-us-crate-barrel.bd8bec56.svg";